<div
  class="iwb-fs-json"
  [class.iwb-fs-json--dark]="isDark"
  (keydown)="onKeyDown($event)">
  <div class="iwb-fs-json__header">
    <div class="iwb-fs-json__title">
      <i class="fa-solid fa-code"></i>
      <span>workflow.json</span>
    </div>
    <div class="iwb-fs-json__actions">
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="toggleTheme()"
        [title]="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
        <i
          class="fa-solid"
          [class.fa-sun]="isDark"
          [class.fa-moon]="!isDark"></i>
        {{ isDark ? 'Light' : 'Dark' }}
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="onFormat()"
        title="Format JSON">
        <i class="fa-solid fa-align-left"></i> Format
      </button>
      <button
        class="btn btn-sm btn-primary"
        (click)="onSave()"
        [disabled]="hasError"
        title="Save (Ctrl+S)">
        <i class="fa-solid fa-check"></i> Save & Close
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="onClose()"
        title="Close (Esc)">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>
  <div class="iwb-fs-json__error" *ngIf="hasError">
    <i class="fa-solid fa-triangle-exclamation"></i>
    {{ errorMessage }}
  </div>
  <ngx-monaco-editor
    class="iwb-fs-json__monaco"
    [options]="editorOptions"
    [(ngModel)]="code"
    (ngModelChange)="onCodeChange($event)">
  </ngx-monaco-editor>
</div>
